import { createFileRoute, Navigate } from "@tanstack/react-router"
import { SearchSchema } from "./list/route"

import "modules/support/lang"

export const Route = createFileRoute("/_base/_auth/support/")({
  component: RouteComponent,
})

function RouteComponent() {
  return <Navigate to="/support/list" search={SearchSchema.parse({})} replace />
}
